import { createApiAxios } from './createApiAxios';
import config from "./config";

// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
const authApi = createApiAxios(config.AUTH_API_BASE_URL, '');

export default authApi;
